export enum ConnectionLevel {
    NoConnection,
    Bad,
    Acceptable,
    Excellent,
}
